var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckboxCheckDisable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 0C16.9902 0 18.3334 1.34315 18.3334 3V15C18.3334 16.6569 16.9902 18 15.3334 18H3.33337C1.67652 18 0.333374 16.6569 0.333374 15V3C0.333374 1.34315 1.67652 0 3.33337 0H15.3334ZM13.803 4.96967L7.33337 11.4393L4.8637 8.96967C4.57081 8.67678 4.09594 8.67678 3.80304 8.96967C3.51015 9.26256 3.51015 9.73744 3.80304 10.0303L6.80304 13.0303C7.09594 13.3232 7.57081 13.3232 7.8637 13.0303L14.8637 6.03033C15.1566 5.73744 15.1566 5.26256 14.8637 4.96967C14.5708 4.67678 14.0959 4.67678 13.803 4.96967Z",
    fill: "#AEB7BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckboxCheckDisable);
export default __webpack_public_path__ + "static/media/icon-checkbox-check-disable.2f10f3312d9a488b3caf590be3e97efc.svg";
export { ForwardRef as ReactComponent };